module.exports = __webpack_public_path__ + "static/media/open_app_logo.2cb051cb.png";